// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-options[data-v-c79a649e] {\n  justify-content: center;\n}\n.disabled[data-v-c79a649e] {\n  color: gray;\n}", ""]);
// Exports
module.exports = exports;
